import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';
import { fetchEventTours } from '../../../actions/event-template-actions';

const EventTourFilter = (props) => {
    const { auth, search, filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const eventTemplates = useSelector(({ eventTemplates }) => eventTemplates);
    const dispatch = useDispatch();

    const getEventToursList = async () => {
        await dispatch(fetchEventTours());
    };
    useEffect(() => {
        getEventToursList();
    }, []);

    const tours = eventTemplates && eventTemplates.tours ? eventTemplates.tours : [];
    const showTennisContent = auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = auth?.feedPreferences?.showPickleballContent;
    const tennisSportTypeIsSelected = search?.filterInputs?.sportTypes?.tennis;
    const pickleballSportTypeIsSelected = search?.filterInputs?.sportTypes?.pickleball;

    const filteredTours = { ...searchTypes };
    if ((tennisSportTypeIsSelected && !pickleballSportTypeIsSelected) || (!pickleballSportTypeIsSelected && !showPickleballContent && showTennisContent)) {
        filteredTours.availableToursList = searchTypes.availableToursList.filter((tour) => {
            const foundTour = tours.find((newTour) => newTour.name === tour.value);
            return foundTour && !!foundTour.isTennisTour;
        });
    } else if ((pickleballSportTypeIsSelected && !tennisSportTypeIsSelected) || (!tennisSportTypeIsSelected && !showTennisContent && showPickleballContent)) {
        filteredTours.availableToursList = searchTypes.availableToursList.filter((tour) => {
            const foundTour = tours.find((newTour) => newTour.name === tour.value);
            return foundTour && !!foundTour.isPickleballTour;
        });
    }
    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'tours'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.tours && (Object.values(filters.tours).indexOf(true) > -1)) || filterModal === 'tours'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Event Series
            </Filter>
            {filterModal === 'tours' && (
                <FilterModal
                    title={'Tours'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={filteredTours}
                            searchTypesPropName={`availableToursList`}
                            filterInputs={filterInputs}
                            filtersPropName={`tours`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    tours: {
                                        ...filterInputs.tours,
                                        [value]: !filterInputs.tours[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventTourFilter;
